<template>
  <div class="">
    <h5>کاربرانی که درس را مطالعه کرده اند.</h5>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">کاربر</th>
        <th scope="col">تاریخ مطالعه</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in readerUsers">
        <td>{{ user.name }} {{ user.last_name }}</td>
        <td>{{ dateConverter(user.created_at, '/', true) }}</td>
      </tr>

      </tbody>
    </table>
    <pagination :meta="pagination" :on-change-page="changePage"/>
  </div>
</template>

<script>
import {dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import Pagination from "@/plugin/components/dashboard/Pagination.vue";

export default {
  name: "LessonReader",
  components: {Pagination},
  props: {
    lessonLink: {}
  },
  data() {
    return {
      readerUsers: [],
      pagination: {},
      page: 1,
    }
  },
  methods: {
    dateConverter,
    async showReaderUsers(page = 1) {
      let form = {
        lessonLink: this.$route.params.slug,
        page: page
      }

      let response = await this.$store.dispatch('Content/readerOfLessonWithoutState', form)
      this.readerUsers = response.data.data.data
      this.pagination = response.data.data.meta
    },
    changePage(page) {
      this.showReaderUsers(page)
    }
  },
  async mounted() {
    // get reader lesson
    await this.showReaderUsers();
  }
}
</script>

<style scoped>

</style>